import React from 'react';
import { PropInfo, CodeExample, SliderProps } from '@cimpress/react-components';

import SliderCode from '!raw-loader!./slider.jsx';
import SliderDemo from './slider.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const SliderDocs = () => {
  const propInfos: PropInfo<SliderProps>[] = [
    {
      name: 'label',
      type: 'string (required)',
      default: '',
      description: 'The label displayed above the slider',
    },
    {
      name: 'onSelect',
      type: 'function (required)',
      default: '',
      description: 'Once a value is selected, this callback function will receive the selected number as an argument',
    },
    {
      name: 'value',
      type: 'number (required)',
      default: '',
      description: 'The current value of the slider',
    },
    {
      name: 'disabled',
      type: 'boolean',
      default: 'false',
      description: 'Setting this to true disables the slider, and greys it out',
    },
    {
      name: 'min',
      type: 'number',
      default: '0',
      description: 'The minimum value that the slider can select (on the left)',
    },
    {
      name: 'max',
      type: 'number',
      default: '100',
      description: 'The maximum value that the slider can select (on the right)',
    },
    {
      name: 'increment',
      type: 'number',
      default: '1',
      description: 'Any real number denoting the increment that the slider will select',
    },
    {
      name: 'selectOnDrag',
      type: 'boolean',
      default: 'false',
      description: 'Setting this to true calls onSelect while dragging the slider, instead of only when it is dropped',
    },
  ];
  const remarks = (
    <div>
      <p>Sliders will expand horizontally to fill whatever container is provided.</p>
      <p>
        For examples of where sliders are used, see the{' '}
        <a href="https://caps.cimpress.io" target="_blank" rel="noopener noreferrer">
          Caps Demo website
        </a>{' '}
        or the{' '}
        <a href="https://apis.documents.cimpress.io" target="_blank" rel="noopener noreferrer">
          Documents APIs webpage
        </a>
        .
      </p>
    </div>
  );

  return (
    <ComponentDoc name="Slider" propInfos={propInfos} remarks={remarks}>
      <SliderDemo />
      <CodeExample code={SliderCode} />
    </ComponentDoc>
  );
};

export default SliderDocs;
